import { render, staticRenderFns } from "./QrBind.vue?vue&type=template&id=957371bc"
import script from "./QrBind.vue?vue&type=script&lang=js"
export * from "./QrBind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('957371bc')) {
      api.createRecord('957371bc', component.options)
    } else {
      api.reload('957371bc', component.options)
    }
    module.hot.accept("./QrBind.vue?vue&type=template&id=957371bc", function () {
      api.rerender('957371bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/qr/QrBind.vue"
export default component.exports